import React, { FC, useEffect, useState } from 'react'
import {
  CustomHandleUpdateSelectedFacetParams,
  FacetOptionObject,
  FacetServiceApi,
  UseReduxSearchProviderResponse,
} from '../types'
import RadioListFacet from '../components/RadioListFacet'
import { SASelectedFacets } from 'types/SearchProvider'
import useReduxSearchProvider from '../hooks/useReduxSearchProvider'

type OnFilterSortOptionsParams = {
  selectedFacets: SASelectedFacets
  currentOptions: ReadonlyArray<FacetOptionObject>
}

type SortFacetProps = {
  baseUrl: string
  nextAppRoute: string
  facetService: FacetServiceApi
  facetName: string
  facetOptions: ReadonlyArray<FacetOptionObject>
  onFilterSortOptions?: (params: OnFilterSortOptionsParams) => ReadonlyArray<FacetOptionObject>
  defaultValue?: string
  useReduxProviderHook?: () => UseReduxSearchProviderResponse
  customHandleUpdateSelectedFacet?: (params: CustomHandleUpdateSelectedFacetParams) => void
  customClickFacetOption?: (params: CustomHandleUpdateSelectedFacetParams) => void
}

const SortFacet: FC<SortFacetProps> = ({
  baseUrl,
  nextAppRoute,
  facetService,
  facetName,
  facetOptions,
  onFilterSortOptions,
  defaultValue,
  useReduxProviderHook = useReduxSearchProvider,
  customHandleUpdateSelectedFacet,
  customClickFacetOption,
}) => {
  const [sortOptions, setSortOptions] = useState<ReadonlyArray<FacetOptionObject>>([])
  const { selectedFacets } = useReduxProviderHook()

  useEffect(() => {
    const filteredSortOptions = !!onFilterSortOptions
      ? onFilterSortOptions({
          selectedFacets,
          currentOptions: facetOptions,
        })
      : facetOptions

    setSortOptions(filteredSortOptions)
  }, [selectedFacets, facetOptions, onFilterSortOptions])

  return (
    <RadioListFacet
      facetService={facetService}
      facetName={facetName}
      facetOptions={sortOptions}
      nextAppRoute={nextAppRoute}
      baseUrl={baseUrl}
      isQueryParam={true}
      defaultValue={defaultValue}
      useReduxProviderHook={useReduxProviderHook}
      customHandleUpdateSelectedFacet={customHandleUpdateSelectedFacet}
      customClickFacetOption={customClickFacetOption}
    />
  )
}

export default SortFacet
